//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Paginate from 'vuejs-paginate';
import informacoesContratoMixin from './informacoesContratoMixin';
import { skipLoading } from '../../../../../../common/functions/loading';
import { formatDatePattern } from '../../../../../../../src/common/functions/date-utils';
import { convertFloatToMoney } from '../../../../../../common/functions/helpers';

export default {
  name: 'PagamentosLiquidadosTabela',
  mixins: [informacoesContratoMixin],
  components: {
    Paginate,
  },
  props: {
    periodo: Number,
    carregando: Boolean,
    paginas: Number,
    busca: {
      type: Function,
    },
  },
  data() {
    return {
      pagamentoResources: this.$api.pagamentoGestao(this.$resource),

      esperar: false,
      limit: 5,
      pagination: {
        page: 1,
      },
      liquidados: [],
      totalPaginas: 0,
      headers: [
        { text: this.$tc('label.cod_pagamento', 1), value: 'idPagamento', sortable: false, width: 110 },
        { text: this.$t('label.numero_acordo'), value: 'idAcordo', sortable: false, width: 110 },
        { text: this.$tc('label.contrato_cliente', 1), value: 'contratoCliente', sortable: false, width: 110 },
        { text: this.$t('label.cod_cliente'), value: 'codCliente', sortable: false, width: 90 },
        { text: this.$tc('label.cliente', 1), value: 'nomCliente', sortable: false, width: 200 },
        { text: this.$tc('label.centro_custo', 1), value: 'centroCusto', sortable: false, width: 200 },
        { text: this.$tc('label.tipo_pagamento', 1), value: 'tipoBeneficio', sortable: false, width: 200 },
        { text: this.$tc('label.solicitante', 1), value: 'usuarioSolicitante', sortable: false, width: 160 },
        { text: this.$t('label.cod_pagamento'), value: 'codPagamento', sortable: false, width: 120, hideColumn: true },
        { text: this.$t('label.dta_liquidacao'), value: 'dtaLiquidacao', sortable: false, width: 130, hideColumn: true },
        { text: this.$tc('label.valor', 1), value: 'valor', sortable: false, width: 120 },
        { text: this.$t('label.usuario_criador'), value: 'usuarioCriador', sortable: false, width: 200 },
      ],
    };
  },
  watch: {
    pagination: {
      handler() {
        this.filtrar();
      },
      deep: true,
    },
    periodo() {
      this.pagination.page = 1;
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.filtrar();
      }, 500);
    },
  },
  methods: {
    filtrar() {
      if (this.esperar) return;
      if (this.periodo) {
        this.esperar = true;
        setTimeout(() => {
          this.buscaPagamentosLiquidados();
        }, 5E2);
      }
    },
    formatDatePattern,
    getMoney(vlrModelo) {
      if (vlrModelo === null) return '-';
      let vlrFormatado = convertFloatToMoney(String(vlrModelo));
      vlrFormatado = vlrFormatado.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const money = vlrFormatado.split('.');
      return `R$ ${money[0].replace(/,/g, '.')},${money[1]}`;
    },

    refazPaginacao() {
      this.pagination.page = 1;
      this.$forceUpdate();
    },
    buscaPagamentosLiquidados() {
      const parametros = {
        numeroPagina: this.pagination.page,
        tamanhoPagina: this.pagination.itemsPerPage,
        asc: !this.pagination.sortDesc[0],
        colunaOrdenacao: this.pagination.sortBy[0],
        competencia: this.periodo,
      };
      skipLoading();
      this.pagamentoResources.liquidados(parametros)
        .then((response) => {
          this.liquidados = response.data.resposta;
          this.totalPaginas = response.data.quantidadeRegistrosPagina;
          this.esperar = false;
          this.$forceUpdate();
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
          this.esperar = false;
        });
    },
  },
  mounted() {
    this.filtrar();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/acompanhamento/PagamentosLiquidadosTabela.vue?vue&type=script&lang=js&